import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { FaLink } from "react-icons/fa6";
import { FaBuildingColumns } from "react-icons/fa6";
import { IoChatbubblesOutline } from "react-icons/io5";
import { FaCaretUp, FaTwitter } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";
import { FaReddit } from "react-icons/fa";
import Select from "react-select";
import Spotmarkettable from "../Component/Spotmarkettable";
import Marketpair from "../Component/Charts/marketpair";
import Currencypair from "../Component/Charts/currency";
import StockPriceChart from "../Component/Charts/pricemovement";
import ExchangetradeChart from "../Component/Charts/exchangetrade";
import ExchangenormaltradeChart from "../Component/Charts/exchangenormalizedchart";
import { getExchageData, getTickerlist } from "../Actions/v1/user";
import { isEmpty } from "../Actions/commonFunction";

function Exchangedash() {
  const params = useParams();
  console.log("🚀 ~ Exchangedash ~ parmas:", params);
  const [exchnageDetails, setExchangeDetails] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [daystabs, setDaystabs] = useState("1d");
  const [daytab2, setDaytab2] = useState("1d");
  const [tickerList, setTickerList] = useState([]);
  const [limit, setLimit] = useState(6);
  const [chartData, setChartData] = useState([]);
  const datas = [
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Ethernet",
      symbol: Images.eth,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "78.2%",
    },
    {
      name: "Citcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$18,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$406,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.eth,
      pair: "BTC/USDT",
      price: "$806,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
    {
      name: "Bitcoin",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$106,551",
      spread: "0.01%",
      pdepth: "$8,893,359",
      mdepth: "$5,337,978",
      hr: "$2,421,878,416",
      volper: "12.2%",
    },
  ];

  const dates = [
    [1625097600000, 10000000],
    [1625184000000, 12000000],
    [1625270400000, 15000000],
    // Add your data here
  ];

  const getExchangeDetails = async (data) => {
    let resp = await getExchageData({
      type: params.type,
      exchangeId: params?.name,
    });
    console.log("🚀 ~ getExchangeDetails ~ resp:", resp);
    if (resp?.status) {
      setExchangeDetails(resp?.data?.[0]);
      setChartData(resp?.data?.[0]?.chartdata);
    }
  };

  const getTickerListdata = async (data) => {
    let resp = await getTickerlist({
      page: currentPage,
      limit,
      id: exchnageDetails?._id,
    });
    console.log("🚀 ~ getTickerListdata ~ resp:", resp);
    if (resp?.status) {
      if (data == "page" && currentPage > 0) {
        setTickerList([...tickerList, resp.data]);
      } else {
        setTickerList(resp.data);
      }
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(exchnageDetails)) {
      getTickerListdata();
    }
  }, [exchnageDetails]);

  useEffect(() => {
    if (currentPage > 0) {
      getTickerListdata("page");
    }
  }, [currentPage]);

  useEffect(() => {
    if (!isEmpty(params?.type) && !isEmpty(params?.name)) {
      getExchangeDetails();
    }
  }, [params]);

  return (
    <div>
      <Header />
      <div className="inner_page">
        <img src={Images.elogo} className="elogo" alt="elogo" />
        <Container className="mt-4">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h4 className="d_white mb-0">
              <img src={exchnageDetails.logo} className="coin" alt="coinname" />{" "}
              {exchnageDetails?.name}
            </h4>
            <img src={Images.coinbag} className="coinbag" alt="coinbag" />
          </div>
          <Row className="mt-3 exchange_dash">
            <Col sm={6} xl={3}>
              <div className="dash_card  px-3 py-3 mt-3">
                <p className="dash_head">Spot Trading Volume(24h)</p>
                <h4>${exchnageDetails?.h_24volume?.current ?? 0}</h4>
                {/* <div className="caret mt-1">
                  {" "}
                  <FaCaretUp />
                  <span>7.08%</span>
                </div> */}
              </div>
            </Col>
            <Col sm={6} xl={3}>
              <div className="dash_card px-3 py-3 mt-3">
                <p className="dash_head">Coins</p>
                <h4>{exchnageDetails?.coins}</h4>
              </div>
            </Col>
            <Col sm={6} xl={3}>
              <div className="dash_card px-3 py-3 mt-3">
                <p className="dash_head">Pairs</p>
                <h4>{exchnageDetails?.pairs}</h4>
              </div>
            </Col>
            <Col sm={6} xl={3}>
              <div className="dash_card dash_link d-flex  flex-wrap px-3 py-3 mt-3">
                <Link to={exchnageDetails?.url}>
                  <FaLink /> {exchnageDetails?.url}
                </Link>
                <Link to={exchnageDetails?.feeurl}>
                  <FaBuildingColumns /> Fees
                </Link>
                {/* <Link to="">
                  <IoChatbubblesOutline /> Chat
                </Link> */}
                <Link to={exchnageDetails?.twitter}>
                  <FaTwitter /> @binance
                </Link>
                <Link to={exchnageDetails?.facebook}>
                  <FaFacebookSquare /> facebook
                </Link>
                <Link to={exchnageDetails?.telegram}>
                  <TbWorld /> Telegram
                </Link>
                <Link to={exchnageDetails?.reddit}>
                  <FaReddit /> Reddit
                </Link>
              </div>
            </Col>
          </Row>

          <div className="d-block d-sm-flex align-items-center justify-content-between mt-4">
            <div>
              <h5 className="d_white">Spot Markets</h5>
              <p className="mt-3 mb-0 d_white">
                Eda Face Listing Platforms ranks the top decentralized exchanges
                based on trading volumes, market share of DeFi markets.
              </p>
            </div>

            <Select
              className="mt-3 mt-sm-0"
              classNamePrefix="select"
              placeholder="All pairs"
            />
          </div>

          <Spotmarkettable
            currentPage={currentPage}
            setCurrentPage={(data) => setCurrentPage(data)}
            data={tickerList}
            itemsPerPage={6}
          />

          <div className="aboutus d_white">
            <div dangerouslySetInnerHTML={{ __html: exchnageDetails?.about }} />

            {/* <h5>About Binance</h5>
            <h6>What Is Binance?</h6>
            <p>
              Binance is the world’s largest crypto exchange by trading volume,
              with $76 billion daily trading volume on Binance exchange as of
              August 2022, and 90 million customers worldwide. The platform has
              established itself as a trusted member of the crypto space, where
              users can buy, sell and store their digital assets, as well as
              access over 350 cryptocurrencies listed and thousands of trading
              pairs. The Binance ecosystem now comprises of Binance Exchange,
              Labs, Launchpad, Info, Academy, Research, Trust Wallet, Charity,
              NFT and more.
            </p>

            <h6>Who Are the Binance Founders?</h6>
            <p>
              The global company was co-founded in China by Changpeng Zhao and
              Yi He. A Chinese-Canadian developer and business executive,
              Changpeng Zhao, who goes by CZ, is the company's CEO. He studied
              at McGill University Montreal and had a successful track record as
              an entrepreneur. His past experiences include Head of Bloomberg
              Tradebook Futures Research & Development team, founder of Fusion
              Systems and Head of Technology at Blockchain.com. Yi He is CMO at
              Binance and Head at Binance Labs, the company’s venture capital
              arm. Yi was previously Vice President at a leading mobile video
              tech company,Yixia Technology, and co-founder of digital asset
              exchange OKCoin.
            </p>

            <h6>When Did Binance Launch?</h6>
            <p>
              Binance was launched in June 2017, and within 180 days grew into
              the largest cryptocurrency exchange in the world.
            </p>

            <h6>Binance Restricted Countries</h6>
            <p>
              Under the Binance Terms of Use, restricted locations include the
              United States, Singapore and Ontario (Canada). However, some
              countries have restricted usage or features might be limited due
              to regulatory reasons, including but not limited to, China,
              Malaysia, Japan, UK and Thailand. Futures and derivatives products
              are also not available in Germany, Italy and The Netherlands. In
              September 2019, a separate dedicated platform for US clients,
              Binance.US, was launched.
            </p>

            <h6>How Much Are Binance Fees?</h6>
            <p>
              The platform is user-friendly and one of the cheapest with a huge
              selection of transaction types and an advanced set of trading
              tools for experienced investors. It charges based on a tiered
              system, from regular users to VIP 9. For regular users, a 0.10%
              maker taker fee is charged for spot trading. In July 2022, Binance
              announced zero-fee trading for BTC spot trading pairs, and in
              August for ETH/BUSD pair.
            </p>

            <h6>
              Is It Possible To Use Leverage or Margin Trading on Binance?
            </h6>
            <p>
              Traders can borrow funds and participate in margin trading on
              Binance Margin, which allows trading cryptocurrencies with up to
              10X leverage. Users can also use derivatives products such as
              Binance Futures, settled in USDT, BUSD or other cryptocurrencies
              and Binance Options to leverage on their trades.
            </p> */}
          </div>

          <div className="mt-5">
            <h5 className="d_white">Binance Statistics</h5>
            <Row className="mt-3">
              <Col xl={6}>
                <div className="maincoin py-3 px-3 rounded-1 mt-3">
                  <h6 className="d_white">Volume by Market Pair</h6>
                  <Marketpair data={exchnageDetails?.vom} />
                </div>
              </Col>
              <Col xl={6}>
                <div className="maincoin py-3 px-3 rounded-1 mt-3">
                  <h6 className="d_white">Volume by Currency</h6>
                  <Currencypair data={exchnageDetails?.voc} />
                </div>
              </Col>
              <Col xl={12}>
                <div className="maincoin py-3 px-3 rounded-1 mt-3">
                  <div className="d-block d-sm-flex align-items-center justify-content-between mb-3">
                    <h6 className="mb-0 d_white">Exchange Trade Volume</h6>
                    <ul className="mb-0  d-flex maincoin rounded-2 px-1 py-1 pricetab gap-1 graphdays mt-2 mt-sm-0">
                      <li
                        className={daystabs === "1d" ? "active" : ""}
                        onClick={() => setDaystabs("1d")}
                      >
                        24h
                      </li>
                      <li
                        className={daystabs === "7d" ? "active" : ""}
                        onClick={() => setDaystabs("7d")}
                      >
                        7d
                      </li>
                      {/* <li
                        className={daystabs === "14d" ? "active" : ""}
                        onClick={() => setDaystabs("14d")}
                      >
                        14d
                      </li> */}
                      <li
                        className={daystabs === "1m" ? "active" : ""}
                        onClick={() => setDaystabs("1m")}
                      >
                        1m
                      </li>
                      {/* <li
                        className={daystabs === "3m" ? "active" : ""}
                        onClick={() => setDaystabs("3m")}
                      >
                        3m
                      </li> */}
                      <li
                        className={daystabs === "1y" ? "active" : ""}
                        onClick={() => setDaystabs("1y")}
                      >
                        1y
                      </li>
                      {/* <li className={daystabs === "log" ? "active" : ""} onClick={() => setDaystabs("log")}>Log</li> */}
                    </ul>
                  </div>
                  <ExchangetradeChart
                    dates={
                      chartData?.find((item) => item.history == daystabs)
                        ?.volumes
                    }
                  />
                </div>
              </Col>
              <Col xl={12}>
                <div className="maincoin py-3 px-3 rounded-1 mt-3">
                  <div className="d-block d-sm-flex align-items-center justify-content-between mb-3">
                    <h6 className="mb-0 d_white">
                      Exchange Normalized Trade Volume
                    </h6>
                    <ul className="mb-0  d-flex maincoin rounded-2 px-1 py-1 pricetab gap-1 graphdays mt-2 mt-sm-0">
                      <li
                        className={daytab2 === "1d" ? "active" : ""}
                        onClick={() => setDaytab2("1d")}
                      >
                        24h
                      </li>
                      <li
                        className={daytab2 === "7d" ? "active" : ""}
                        onClick={() => setDaytab2("7d")}
                      >
                        7d
                      </li>
                      {/* <li
                        className={daytab2 === "14d" ? "active" : ""}
                        onClick={() => setDaytab2("14d")}
                      >
                        14d
                      </li> */}
                      <li
                        className={daytab2 === "1m" ? "active" : ""}
                        onClick={() => setDaytab2("1m")}
                      >
                        1m
                      </li>
                      {/* <li
                        className={daytab2 === "3m" ? "active" : ""}
                        onClick={() => setDaytab2("3m")}
                      >
                        3m
                      </li> */}
                      <li
                        className={daytab2 === "1y" ? "active" : ""}
                        onClick={() => setDaytab2("1y")}
                      >
                        1y
                      </li>
                      {/* <li className={daystabs === "log" ? "active" : ""} onClick={() => setDaystabs("log")}>Log</li> */}
                    </ul>
                  </div>
                  <ExchangenormaltradeChart
                    dates={
                      chartData?.find((item) => item.history == daystabs)
                        ?.normal_vol
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default Exchangedash;
